'use es6';

export const hasFileManagerUrl = (state, guid) => state.fileManager && state.fileManager.urls.has(guid);
export const getFileByPath = (state, path) => {
  return state.files[path];
};